export default __webpack_public_path__ + "static/media/p2.bfeac394.jpg";